import { atom } from 'recoil';
import { IGetBrandColorResponse } from 'ui/interface/brand/color/getBrandColor';

export const brandColorAtom = atom<IGetBrandColorResponse | null>({
  key: 'brandColorAtom',
  default: null,
});
